/**
 * Demo sandbox API (docs/features/demo-sandbox/plan.md §3.4, §4.4).
 */
import { apiClient } from '../api-client';
import type { PersonaLoginResponseDto, SandboxExtendResponseDto } from '../../dtos/demo/sandbox.dto';

export class SandboxService {
  /** Sign in as a seeded persona (the sandbox owner, or a persona they switched to). */
  static async personaLogin(persona: string): Promise<PersonaLoginResponseDto> {
    const response = await apiClient.post<PersonaLoginResponseDto>('/demo/persona-login', { persona });
    if (response.success && response.data?.tokens) return response.data;
    throw new Error(response.error?.message || 'Could not switch persona');
  }

  /** The owner extends the sandbox once by 7 days (D4). */
  static async extend(): Promise<SandboxExtendResponseDto> {
    const response = await apiClient.post<SandboxExtendResponseDto>('/demo/sandbox/extend', {});
    if (response.success && response.data) return response.data;
    throw new Error(response.error?.message || 'Could not extend the sandbox');
  }
}

export default SandboxService;
